module.exports = __webpack_public_path__ + "static/media/left.10cd97ef.png";